/**
 * @param data
 * This function create list view with restrict distance and only show 9 items
 */
var createListView = (function (data) {
    // empty view every time before create new view
    $('.c-search-results-list__items').html('');
    if(data.length == 0){
        $('.c-return-point-result--list-view>.subtitle').hide();
        $('.c-search-results-list__items').prepend("<div class='subtitle u-text--center'>It doesn't look like there is a return point matching your filter selection. Please try again.</div>");
    }else{
        $('.c-return-point-result--list-view>.subtitle').show();
    }
    var returnPointsListWithinDistance = [];
    // return point array
    var otcArr = [];
    var rvmArr = [];
    var adArr = [];
    var dsArr = [];
    for(var i =0; i< data.length; i++){
        var distance = data[i].cp_distance;
        var returnPointType = data[i].cp_collection_point_type;
        if(distance <= 50){
            returnPointsListWithinDistance.push(data[i]);
            if(returnPointType == 'Over The Counter'){
                otcArr.push(data[i]);
            }
            if(returnPointType == 'Reverse Vending Machine'){
                rvmArr.push(data[i]);
            }
            if(returnPointType == 'Automated Depot'){
                adArr.push(data[i]);
            }
            if(returnPointType == 'Donation Station'){
                dsArr.push(data[i]);
            }
        }
    }

    if (returnPointsListWithinDistance.length == 0) {
        $('.c-search-results-list-wrapper').prepend("<div class='subtitle u-text--center'>It doesn't look like there is a return point matching your filter selection. Please try again.</div>");
    }
    

    //Save to global variable then create initial list.
    window.locationDataWT = returnPointsListWithinDistance.slice();
    var returnPointsList = returnPointsListWithinDistance.slice(0,10);



    var returnPointResultsArr = [];
    var visiableOtcRP = otcArr.splice(0,8);
    var visiableRvmRP = rvmArr.splice(0,8);
    var visiableAdRP = adArr.splice(0,8);
    var visiableDsRP = dsArr.splice(0,8);

    // create each return point type object
    var otcObj = {};
    var rvmObj = {};
    var adObj = {};
    var DsObj = {};
    for(var i =0; i< globalReturnPointsType.length; i++){
        if(globalReturnPointsType[i].title == "Over the Counter"){
            otcObj = {
                "id":("Over the Counter Sites").toLowerCase().replace(/ /g,"-"),
                "title" : "Over the Counter Sites",
                "featureImage": globalReturnPointsType[i].featureImage,
                "featureDetail": globalReturnPointsType[i].featureDetail,
                "features": globalReturnPointsType[i].features,
                "data": visiableOtcRP
            }
        }
        if(globalReturnPointsType[i].title == "Reverse Vending Machine"){
            rvmObj = {
                "id":("Reverse Vending Machines").toLowerCase().replace(/ /g,"-"),
                "title" : "Reverse Vending Machines",
                "featureImage": globalReturnPointsType[i].featureImage,
                "featureDetail": globalReturnPointsType[i].featureDetail,
                "features": globalReturnPointsType[i].features,
                "data": visiableRvmRP
            }
        }
        if(globalReturnPointsType[i].title == "Automated Depot"){
            adObj = {
                "id":("Automated Depots").toLowerCase().replace(/ /g,"-"),
                "title" : "Automated Depots",
                "featureImage": globalReturnPointsType[i].featureImage,
                "featureDetail": globalReturnPointsType[i].featureDetail,
                "features": globalReturnPointsType[i].features,
                "data": visiableAdRP
            }
        }
        if(globalReturnPointsType[i].title == "Donation Station"){
            DsObj = {
                "id":("Donation Stations").toLowerCase().replace(/ /g,"-"),
                "title" : "Donation Stations",
                "featureImage": globalReturnPointsType[i].featureImage,
                "featureDetail": globalReturnPointsType[i].featureDetail,
                "features": globalReturnPointsType[i].features,
                "data": visiableDsRP
            }
        }
    }
    // push all object into array
    returnPointResultsArr.push(otcObj, rvmObj, adObj, DsObj);
    // remove empty array
    returnPointResultsArr = returnPointResultsArr.filter(function(returnPoint) { 
        return returnPoint.data.length !== 0
    });
    
    // sort return point results array by real distance
    returnPointResultsArr.sort(sortRealDistance);
    // create features list
    function features(featuresArr){
        var featuresList = "";
        for (var a =0; a< featuresArr.length; a++){
            featuresList += "<li>"+ featuresArr[a] +"</li>";
        }
        return featuresList;
    }
    // create list
    // createList(returnPointResultsArr);

 
    // add dynamic height for each return point section
    addDynamicHeight();
    var width = $(window).width();
    $(window).resize(function(){
        // prevent window scroll function trigger resize on mobile
        if ($(window).width() != width) {
            addDynamicHeight();
            toggleMoreLocationButton();
        }
    });
    function createList(returnPointResultsArr){
        for(var i =0; i< returnPointResultsArr.length; i++){
            // create first item of each return point type section
            var typeClass = returnPointResultsArr[i].title.replace(/ /g,"-");
            var hideMoreLocationBtn = false;
            if($(window).outerWidth()<680){
                if(returnPointResultsArr[i].data.length < 3){
                    hideMoreLocationBtn = true;
                }
            }else{
                if($(window).outerWidth()<992 && $(window).outerWidth()>679){
                    if(returnPointResultsArr[i].data.length < 2){
                        hideMoreLocationBtn = true;
                    }
                }else{
                    if(returnPointResultsArr[i].data.length < 3){
                        hideMoreLocationBtn = true;
                    }
                }
            }
            $('.c-search-results-list__items').append(
                "<div class='"+typeClass+" c-return-point-type-section'>\n\
                    <div class='o-layout__item c-search-results-list__item'>\n\
                        <div class='c-return-point-card__item c-return-point-card__info-item u-box-shadow-free'>\n\
                            <div class='c-return-point-card--nearest-indicator'>\n\
                                Your nearest: <h3>" +returnPointResultsArr[i].title+ "</h3>\n\
                            </div>\n\
                            <div class='c-return-point-card--bullest-list'>\n\
                                <ul class='c-bullet-list'>" + features(returnPointResultsArr[i].features) + "</ul>\n\
                            </div>\n\
                            <div class='c-return-point-card--info-links'>\n\
                                <button class='c-return-point-card--info-btn c-more-location-control " + (hideMoreLocationBtn == true ? 'u-hidden' : '') + "' \n\
                                id='c-detail--more-location-" +returnPointResultsArr[i].id+ "'>More locations</button>\n\
                            </div>\n\
                        </div>\n\
                    </div>\n\
                </div>"
            )
            // create cards / return point items for each return point type section
            // toggleMoreLocationButton(returnPointResultsArr[i].data, i);

            for(var j =0; j< returnPointResultsArr[i].data.length; j++){
                var rpTitle = returnPointResultsArr[i].data[j].cp_title;
                var rpStatus = returnPointResultsArr[i].data[j].cp_status;
                var rpType = returnPointResultsArr[i].data[j].cp_collection_point_type;
                var rpSuburb = returnPointResultsArr[i].data[j].cp_city;
                var rpOpenCloseStatus = returnPointResultsArr[i].data[j].cp_open_close_state_messages.map;
                var rpAddress = returnPointResultsArr[i].data[j].cp_address;
                var rpTypeIconUrl = returnPointResultsArr[i].data[j].cp_type_icon;
                var rpUrl = returnPointResultsArr[i].data[j].cp_url;
                var rpDistance = returnPointResultsArr[i].data[j].cp_distance;
                var rpStatusClass = returnPointResultsArr[i].data[j].cp_status_class;

                $('.'+typeClass).append(
                    "<div class='o-layout__item c-search-results-list__item' data-bitwise='"+ returnPointResultsArr[i].data[j].cp_bitwise_sum +"'>\n\
                        <div class='c-return-point-card__item c-return-point-card__in-list'>\n\
                            <a href='" + rpUrl + "' class='c-return-point-card--link'>\n\
                            <div class='c-return-point-card__top'>\n\
                                <div class='c-return-point-card--status " + rpStatusClass + "'>" + rpStatus + "</div>\n\
                                <div class='c-return-point-card--type__icon'>" + "<img src='"+ rpTypeIconUrl + "' alt='" + rpType + "'></div>\n\
                                <div class='c-return-point-card--type__text'>" + rpType + "</div>\n\
                                <div class='c-return-point-card--name__suburb'><h4>" + rpSuburb + "</h4></div>\n\
                                <div class='c-return-point-card--name__text'>" + rpTitle + "</div>\n\
                            </div>\n\
                            <div class='c-return-point-card--openning-hours'>" + rpOpenCloseStatus + "</div>\n\
                            <div class='c-return-point-card__bottom'>\n\
                                <div class='c-return-point-card--address'>" + rpAddress + "</div>\n\
                                <div class='c-return-point-card--distance'>" + rpDistance + " km away</div>\n\
                            </div>\n\
                            </a>\n\
                        </div>\n\
                    </div>"
                )
            }
        }
    }


    // add dynamic height for each return point type section
    function addDynamicHeight(){
        $('.c-return-point-type-section').each(function(){
            $(this).css('height', getSectionDynamicData($(this))[1]);
            $(this).addClass('c-hide-extra-item');
            $(this).children('.c-search-results-list__item').find('a').removeAttr('tabindex');
            $(this).children('.c-search-results-list__item').removeAttr('aria-hidden');
            $(this).children('.c-search-results-list__item:not(:lt('+ getSectionDynamicData($(this))[0] +'))').find('a').attr('tabindex',"-1");
            $(this).children('.c-search-results-list__item:not(:lt('+ getSectionDynamicData($(this))[0] +'))').attr('aria-hidden',true);
        });
    }
    // return visiable number and max height for each return point type section
    function getSectionDynamicData(currentItem){
        var visiableNumber = 0;
        var maxHeight = 0;
        if(currentItem.children().length > 1){
            if($(window).outerWidth()<680){
                if(currentItem.children().length == 2){
                    maxHeight = currentItem.children('.c-search-results-list__item:eq(0)').innerHeight() + 
                    currentItem.children('.c-search-results-list__item:eq(1)').innerHeight() + 40;
                    visiableNumber = 2;
                }else{
                    maxHeight = currentItem.children('.c-search-results-list__item:eq(0)').innerHeight() + 
                    currentItem.children('.c-search-results-list__item:eq(1)').innerHeight() + 
                    currentItem.children('.c-search-results-list__item:eq(2)').innerHeight() + 90;
                    visiableNumber = 3;
                }
            }else{
                if(currentItem.children('.c-search-results-list__item:eq(0)').innerHeight() > 
                    currentItem.children('.c-search-results-list__item:eq(1)').innerHeight()){
                    maxHeight = currentItem.children('.c-search-results-list__item:eq(0)').innerHeight() + 50;
                }else{
                    maxHeight = currentItem.children('.c-search-results-list__item:eq(1)').innerHeight() + 50;
                }
                if($(window).outerWidth()<992 && $(window).outerWidth()>679){
                    visiableNumber = 2;
                }else{
                    visiableNumber = 3;
                }
            }
        }
        return [visiableNumber, maxHeight];
    }

    // hide or show more loction button
    function toggleMoreLocationButton(){
        $('.c-return-point-type-section').each(function(){
            if($(window).outerWidth()<680){
                if($(this).children().length < 4){
                    $(this).children().find('.c-more-location-control').addClass('u-hidden');
                }else{
                    $(this).children().find('.c-more-location-control').removeClass('u-hidden');
                }
            }else{
                if($(window).outerWidth()<992 && $(window).outerWidth()>679){
                    if($(this).children().length < 3){
                        $(this).children().find('.c-more-location-control').addClass('u-hidden');
                    }else{
                        $(this).children().find('.c-more-location-control').removeClass('u-hidden');
                    }
                }else{
                    if($(this).children().length < 4){
                        $(this).children().find('.c-more-location-control').addClass('u-hidden');
                    }else{
                        $(this).children().find('.c-more-location-control').removeClass('u-hidden');
                    }
                }
            }
        });
    }
    // more location button click function
    $('.c-more-location-control').click(function(){
        var currentBtnParent = $(this).parents('.c-return-point-type-section');
        var visibleChildren = "";
        var currentReturnPointTypeSectionHeight = currentBtnParent[0].scrollHeight;
        var extraItemsHidden = currentBtnParent.toggleClass('c-hide-extra-item').hasClass('c-hide-extra-item');
        visibleChildren = currentBtnParent.children('.c-search-results-list__item:not(:lt('+ getSectionDynamicData(currentBtnParent)[0] +'))');

        // toggle parent height
        currentBtnParent.css('height', !extraItemsHidden ? 
                    currentReturnPointTypeSectionHeight : getSectionDynamicData(currentBtnParent)[1]);
        if(extraItemsHidden){
            visibleChildren.find('a').attr('tabindex',"-1");
            visibleChildren.attr('aria-hidden',true);
            scrollToItems($(currentBtnParent).offset().top);
        }else{
            visibleChildren.find('a').removeAttr('tabindex');
            visibleChildren.attr('aria-hidden',false);
            scrollToItems($(visibleChildren[0]).offset().top);
        }
    });
    function scrollToItems(targetSection){
        $('html, body').animate({ scrollTop: targetSection
            - $('.c-live-return-wrapper').innerHeight()
            - $('.c-inner-header').innerHeight() - 10 
        }, "slow");
    }
    // compare real distance
    function sortRealDistance(a,b) {
        if (a.data[0].cp_realDistance < b.data[0].cp_realDistance)
            return -1;
        if (a.data[0].cp_realDistance > b.data[0].cp_realDistance)
            return 1;
        return 0;
    }

    scrollableList(returnPointsList);
});

function scrollableList(returnPointsList){
    for (var i = 0; i < returnPointsList.length && i < 10; i++) {
        var rpTitle = returnPointsList[i].cp_title;
        var rpStatus = returnPointsList[i].cp_status;
        var rpType = returnPointsList[i].cp_collection_point_type;
        var rpSuburb = returnPointsList[i].cp_city;
        var rpOpenCloseStatus = returnPointsList[i].cp_open_close_state_messages.map;
        var rpAddress = returnPointsList[i].cp_address;
        var rpTypeIconUrl = returnPointsList[i].cp_type_icon;
        var rpUrl = returnPointsList[i].cp_url;
        var rpDistance = returnPointsList[i].cp_distance;
        var rpStatusClass = returnPointsList[i].cp_status_class;
        var dataClick = i;

        $('.c-search-results-list__items').append(
            "<a class='location-list__item' href='" + rpUrl + "' data-bitwise='"+ returnPointsList[i].cp_bitwise_sum +"' data-click='" + dataClick + "'>\n\
                <img src='"+ rpTypeIconUrl + "' alt='" + rpType +"' class='location-list__image'>\n\
                <div class='location-list__description'>\n\
                    <h5 class='location-list__description-title'>" + rpTitle + "</h5>\n\
                    <p>" + rpType + "</p>\n\
                    <p>" + rpAddress + " - " + rpDistance + " km</p>\n\
                    <p class='" + rpStatusClass + "'>" + rpOpenCloseStatus +"</p>\n\
                </div>\n\
            </a>\n\
        ");
    }
}

function getFilteredList(filters) {
    var newList = [];
    
    for (var i = 0; newList.length < 10; i++) {
        var returnPointType = data[i].cp_collection_point_type;
        for (var j = 0; j < filters.length; j++) {
            if (returnPointType == filters[j]){
                newList.push(data[i]);
            }
        }
    }
    $('.c-search-results-list__items').empty();
    scrollableList(newList);
}

export default createListView;


// WEBPACK FOOTER //
// ./FE-Build/src/js/modules/createListView.js